"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { type ReactNode } from "react";

// Initialize PostHog at module level so it's ready before any component renders.
// This avoids a race condition where events fired in early useEffects
// (e.g. CR_SIGNUP on connect-account) were silently dropped.
if (typeof window !== "undefined") {
  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;
  const uiHost = process.env.NEXT_PUBLIC_POSTHOG_UI_HOST;

  if (apiKey && !posthog.__loaded) {
    posthog.init(apiKey, {
      api_host: host || "https://app.posthog.com",
      ui_host: uiHost || "https://us.posthog.com",
      capture_pageleave: true,
      autocapture: true,
      persistence: "localStorage+cookie",
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: "[data-sensitive]",
      },
      loaded: (ph) => {
        if (process.env.NODE_ENV === "development") {
          ph.debug();
        }
      },
    });
  }
}

export function PostHogProvider({ children }: { children: ReactNode }) {
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
